import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const { status, cuisine, city } = payload || {}

    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_RESTAURANTS, {
      queryParams: {
        limit: 2000,
        status,
        cuisine,
        city
      }
    })
  },

  parse(raw = {}, payload = {}) {
    if (raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to fetch restaurants',
        data: null,
      }
    }

    // Dans la nouvelle API, le tableau de restaurants est dans raw.data.data
    const restaurants = raw.data?.data || []
    const pagination = raw.data || {}

    // 1. Formattage des données
    const formatted = restaurants.map(r => {
      const balance = r.balance || r.metadata?.wallet?.balance || r.wallet?.balance || 0;
      
      return {
        id: r.id,
        storeName: r.storeName || r.name || '',
        name: r.storeName || r.name || '',
        email: r.email || '',
        phone: r.phone || '',
        address: typeof (r.address?.address || r.address) === 'string' 
          ? (r.address?.address || r.address) 
          : '',
        city: typeof (r.address?.city || r.city) === 'string' 
          ? (r.address?.city || r.city) 
          : '',
        status: r.status,
        isVisible: r.isVisible ?? (r.status === 'approved' || r.status === 'active'),
        rating: r.statistics?.rating || r.rating || 0,
        totalOrders: r.statistics?.ordersCount || r.stats?.totalOrders || 0,
        totalOrdersDelivered: r.statistics?.ordersCount || r.stats?.totalOrdersDelivered || 0,
        totalDishes: r.totalDishes || 0,
        balance: balance,
        image: r.logo || r.image
      };
    })

    // 2. Application du filtre search sur les propriétés du restaurant
    const searchTerm = (payload?.search || '').trim().toLowerCase()

    const filtered = searchTerm
      ? formatted.filter(r => {
          return (
            r.name.toLowerCase().includes(searchTerm) ||
            r.email.toLowerCase().includes(searchTerm) ||
            r.phone.toLowerCase().includes(searchTerm) ||
            r.address.toLowerCase().includes(searchTerm) ||
            r.city.toLowerCase().includes(searchTerm)
          )
        })
      : formatted

    // === Tri dynamique selon payload.sortKey et sortOrder ===
    let finalData = filtered
    const { sortKey, sortOrder } = payload || {}
    if (sortKey) {
      const order = sortOrder === 'desc' ? -1 : 1
      finalData = [...finalData].sort((a, b) => {
        const valA = a?.[sortKey]
        const valB = b?.[sortKey]
        if (typeof valA === 'string' && typeof valB === 'string') return valA.localeCompare(valB) * order
        if (typeof valA === 'number' && typeof valB === 'number') return (valA - valB) * order
        return 0
      })
    }

    // === Pagination locale ===
    const { page = 0, limit = 20 } = payload || {}
    const paginated = finalData.slice(page * limit, (page + 1) * limit)

    // 3. Retour des données filtrées
    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: searchTerm ? filtered.length : (pagination.total || formatted.length),
        result: paginated,
      },
    }
  },
}